import { ExtraOptions, Routes } from '@angular/router';
import { resourceGuard } from '@guards';
import { AccountResolver, DashboardResolver, SiteResolver } from '@resolvers';
import { AccountComponent, MonitorUiComponent, SiteComponent } from 'src/app/components/views';
import { PermissionEnum } from 'src/app/models';

enum Routing {
  doc = 'doc',
  list = 'list',
  configured = 'configured',
  history = 'history',
  root = '',
  viewAccount = 'details/:accountId/view-account',
  viewSite = 'details/:siteId/view-site',
}

export const routerOptions: ExtraOptions = {
  enableTracing: false,
  onSameUrlNavigation: 'reload',
};

export const mainRoutes: Routes = [
  {
    canActivate: [resourceGuard(PermissionEnum.read)],
    component: AccountComponent,
    path: Routing.viewAccount,
    resolve: { data: AccountResolver },
  },
  {
    canActivate: [resourceGuard(PermissionEnum.update)],
    component: SiteComponent,
    path: Routing.viewSite,
    resolve: { data: SiteResolver },
  },
  {
    path: Routing.doc,
    redirectTo: '/doc/index.html',
  },
  {
    canActivate: [resourceGuard(PermissionEnum.read)],
    component: MonitorUiComponent,
    path: Routing.root,
    pathMatch: 'full',
    resolve: { updates: DashboardResolver },
  },
  {
    path: '**',
    redirectTo: '/',
  },
];
